import axios from 'axios';

import createRequestOptions from '../helpers/createRequestOptions';

export const SendForm = (data, type) => axios(createRequestOptions(data, type))
  .then(res => res.data);